import {useEffect, useRef, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import { EmployerContribution } from "./EmployerContribution";
import { EmployeeContribution } from "./EmployeeContribution";
import { EmployeeZeroContribution } from "./EmployeeZeroContribution";
import { EmployerZeroContribution } from "./EmployerZeroContribution";
import { PreviousContribution } from "./PreviousContribution";
import { ContributionAdjustmentDetails } from 'enrollment/queries/useV3ContributionAmountQuery/utils/types';
import { hsaContributionsIntial, updateScheduledContribution } from 'enrollment/services';
import { INITIAL_CONTRIBUTION_ADJUSTMENTS } from "enrollment/components/ContributionsCard/utils/constants";
import { isUserAllowedToSubmit } from "../../utils";
import { PsButtonTuner } from 'stencilSetup';
import { EsignatureModal } from "../../../../features/Plans/EsignatureModal";


export function HsaContribution(props: any) {
  const dispatch = useDispatch();
  const { t } = useTranslation('pages.financial');
  const v3HSAData = useSelector(hsaContributionsIntial);
  const initialContributionData = props.contributionData;
  const[contributionAdjustments, setContributionAdjustments] = useState<ContributionAdjustmentDetails>(INITIAL_CONTRIBUTION_ADJUSTMENTS); // should be inititalised with adjustments from the latest data present in the store
  const showCards = v3HSAData.previous_org_contribution === false || v3HSAData.previous_org_contribution === null || v3HSAData.previous_org_contribution_amount > 0;
  const resetedScheduledContribution = useRef(false);

  const [isSubmitButtonValid, setIsSubmitButtonValid] = useState(
    contributionAdjustments.employeeisZero || isUserAllowedToSubmit(v3HSAData, showCards)
  );

  useEffect(() => {
    const submitButtonValid = contributionAdjustments.employeeisZero || isUserAllowedToSubmit(v3HSAData, showCards);
    setIsSubmitButtonValid(submitButtonValid);
    if (!resetedScheduledContribution.current && contributionAdjustments.employeeisZero) {
      const resetLumpSumContributions = v3HSAData.scheduled_contribution.map((item: any) => {
        return { ...item, scheduled_subscriber_contribution: "0.00", scheduled_subscriber_lump_sum_contribution: "0.00" };
      });
      dispatch(updateScheduledContribution({ scheduled_contribution: resetLumpSumContributions, disable_hsa_form: false }));
      resetedScheduledContribution.current = true;
    }
  }, [v3HSAData, showCards, contributionAdjustments.employeeisZero]);

  const handleSubmit = () => {
    props.onHsaSubmitted(v3HSAData);
  };

  const emptyFunction = () => {
    return;
  };


  return(
    <div data-testid="hsa-contribution">
      <PreviousContribution initialContributionData={initialContributionData}
                            setContributionAdjustments={setContributionAdjustments}
                            prevContributionGiven={v3HSAData?.previous_org_contribution_amount > 0} 
                            resetHsaCalculationValues={props.resetHsaCalculationValues}/>
      {showCards &&
        <>
          {contributionAdjustments.employerisZero ? <EmployerZeroContribution/> :
            <EmployerContribution contributionAdjustments={contributionAdjustments}/>}
          {contributionAdjustments.employeeisZero ? <EmployeeZeroContribution/> :
            <EmployeeContribution contributionAdjustments={contributionAdjustments} onResetChanges={props?.resetHsaCalculationValues}/>}
        </>
      }
      <div className="border-top px-5 py-4 text-center text-md-left">
        {props.showEsignatureModal ? (
          <EsignatureModal
            isFinancial={true}
            setEsignElectionData={handleSubmit}
            carrierLogoUrl={props.plan?.carrier_logo_url}
            carrierName={props.plan?.carrier}
            data={props.plan?.esign_data}
            planId={props.plan?.plan_id}
            setModalRequired={emptyFunction}
          />
        ) : (
          <PsButtonTuner
            buttonId="hsa-submit-contribution"
            data-testid='submit-contribution-test'
            label={t('looksGood')}
            level="primary"
            onClick={() => handleSubmit()}
            disabled={!isSubmitButtonValid}
          />
        )}
      </div>
    </div>
  );
}


